import { render, staticRenderFns } from "./Notifications.html?vue&type=template&id=3641e4d4&scoped=true&external"
import script from "./Notifications.js?vue&type=script&lang=js&external"
export * from "./Notifications.js?vue&type=script&lang=js&external"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=3641e4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641e4d4",
  null
  
)

export default component.exports